// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1uui6","buttons":"styles_buttons__1CgOS"};